<template>
  <div class="content--sinoreg page--cadastroNascimento">
    <HeaderForSection :icone="5"
                      :data-inicio="dataInicio" />

    <RegistroLegado :prop-cartorio="dadosCartorio"
                    @receiveData="receiveData" />

    <NascidoLegado :prop-cartorio="dadosCartorio"
                   :prop-registro="registro"
                   :prop-updated="registroUpdated"
                   @receiveNascido="receiveNascido"
                   @rascunhoId="rascunhoId" />

    <div class="cadastroNasc_footer mb-2 border-top border-primary pt-3">
      <div class="row no-gutters justify-content-end align-items-center">
        <div class="d-inline-block">
          <b-link class="btn btn-sm btn-dark"
                  type="button"
                  :to="{ name: 'rei_dashboard' }">
            Voltar
          </b-link>
        </div>

        <div class="d-inline-block ml-2">
          <button class="btn btn-sm btn-primary"
                  type="button"
                  @click="validateInputs()">
            Cadastrar Registro
          </button>
        </div>
      </div>
    </div>

    <b-modal v-if="showModal"
             id="modalErrors"
             ref="modalErrors"
             centered
             size="lg"
             :visible="true"
             hide-header
             no-close-on-backdrop
             no-close-on-esc
             @hide="showModal = false">
      <label for=""
             class="ml-3">
        Escolha qual registro deseja gerar matrícula e CPF:
      </label>
      <div class="row">
        <div class="col-2 d-flex justify-content-center">
          <label for=""
                 class="label">Matrícula</label>
        </div>
        <div class="col-1">
          <label for=""
                 class="label">CPF</label>
        </div>
        <div class="col-9">
          <label for=""
                 class="label">Nome do Registrado</label>
        </div>
      </div>
      <div v-for="(nascido, index) in nascidos"
           :key="index"
           class="my-2">
        <div class="row">
          <div class="col-2 d-flex justify-content-center">
            <span class="custom-control custom-switch d-flex justify-content-center">
              <input :id="`gerar_matricula_${index}`"
                     v-model="nascido.gerar_matricula"
                     class="custom-control-input"
                     :name="`gerar_matricula_${index}`"
                     type="checkbox"
                     :checked="nascido.registrado"
                     :value="true"
                     :disabled="nascido.registrado || !!nascido.matricula">
              <label class="custom-control-label label"
                     :for="`gerar_matricula_${index}`" />
            </span>
          </div>
          <div class="col-1">
            <span class="custom-control custom-switch">
              <input :id="`gerar_cpf_${index}`"
                     v-model="nascido.gerar_cpf"
                     class="custom-control-input"
                     :name="`gerar_cpf_${index}`"
                     type="checkbox"
                     :value="true"
                     :disabled="nascido.matricula || !nascido.gerar_matricula">
              <label class="custom-control-label label"
                     :for="`gerar_cpf_${index}`" />
            </span>
          </div>
          <div class="col-9">
            {{ nascido.nome }}
          </div>
        </div>
      </div>
      <div slot="modal-footer"
           class="modalAddGenitor_footer">
        <button class="btn btn-dark px-3 btn-sm mr-2"
                type="button"
                @click="showModal = false">
          Voltar
        </button>
        <button class="btn btn-secondary btn-sm px-3"
                type="button"
                @click="gerarRegistros()">
          Gerar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* components */
  import HeaderForSection from '@/components/SofiaRei/HeaderForSection.vue'
  import NascidoLegado from '@/components/SofiaRei/Nascimento/SegundaVia/NascidoLegado.vue'
  import RegistroLegado from '@/components/SofiaRei/Nascimento/SegundaVia/RegistroLegado.vue'

  /* services */
  import NascimentoService from "@/services/Registros/Nascimento"
  import RegistrosService from "@/services/Registros"

  /* constants */
  import objSwal from '@/constants/swalValues'

  /* outros */
  import Swal from 'sweetalert2'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CadastroNascimento',
    components: {
      HeaderForSection,
      RegistroLegado,
      NascidoLegado,
    },
    provide () {
      return {
        $validator: this.$validator,
      }
    },
    data () {
      return {
        idNasc: null,
        registro: {},
        dataToSend: {
          local: {}
        },
        passoAtivo: 0,
        passos: [
          { texto: 'Nascido' },
          { texto: 'Outras Informações' },
          { texto: 'Registro' }
        ],
        dadosCartorio: {},
        error: false,
        dataInicio: '',
        showModal: false,
        nascidos: [],
        gerados: [],
        local: null,
        genitores: null,
        partes: null,
        nascimento_informacao: null,
        showModalAverbacao: false,
        registroUpdated: false
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
      }),
    },
    mounted () {
      this.idNasc = this.$route.params.idNasc
      this.getCartorio()
    },
    methods: {
      validateResgistro () {
        window.scrollTo({top: 0, behavior: 'smooth'})

        if (this.$route.params.idNasc === 'novo') return

        if (this.$route.params.idNasc !== 'novo') {
          this.dataToSend.registro.rascunho_id = this.idNasc

          let check = { ...this.dataToSend.registro }
          objSwal.error.title = 'Erro'

          if (!check.digitador || !check.escrevente || !check.data_registro) {
            objSwal.error.text = 'Favor confirmar todos os dados do Registrador'
            return Swal.fire(objSwal.error)
          }

          if (!check.folha || !check.termo || !check.livro || !check.lado) {
            objSwal.error.text = 'Informar todos os dados do registro'
            return Swal.fire(objSwal.error)
          }

          return this.verifyGemeos()
        }
      },
      verifyGemeos () {
        const { pessoa } = this.dataToSend.registro
        let { gemeos } = this.dataToSend

        /**
         * Verificamos se existe gemeos e se não existir definimos como um
         * array vazio
         */
        if (!gemeos || !gemeos.length) gemeos = []

        gemeos = gemeos.map(gemeo => {
          if (gemeo.local) this.local = gemeo.local
          if (gemeo.genitores) this.genitores = gemeo.genitores
          if (gemeo.nascimentoInformacao) this.nascimento_informacao = gemeo.nascimentoInformacao
          if (gemeo.partes) this.partes = gemeo.partes

          gemeo = this.tratarGemeo(gemeo)

          return gemeo
        })

        // Pegamos os dados do nascido para exibir no modal para poder gerar cpf
        const nascido = {
          ...this.dataToSend,
          nome: pessoa.nome,
          sexo: pessoa.sexo,
          gerar_cpf: false,
          gerar_matricula: true,
          registrado: true
        }

        this.nascidos = [
          nascido,
          ...gemeos
        ]

        if (this.nascidos.length > 1) {
          this.showModal = true
        } else {
          this.cadastrarNascimento()
        }
      },
      tratarGemeo (gemeo) {
        const { local, registro, nascimento_informacao, sequenciaLivro } = this.dataToSend

        const nascido = {
          ...gemeo,
          gerar_cpf: false,
          gerar_matricula: false,
          gemeos: [],
          local: { ...local },
          nascimento_informacao: { ...nascimento_informacao },
          recem_nascido: {
            anomalias_ou_defeitos: null,
            cor_pele: null,
            indice_apgar_1_minuto: null,
            indice_apgar_5_minuto: null,
            peso: null,
          },
          sequenciaLivro: { ...sequenciaLivro },
          registro: {
            ...registro,
            pessoa: gemeo.pessoa ? { ...gemeo.pessoa } : { ...registro.pessoa },
            numero_declaracao_nascido_vivo: gemeo.numero_declaracao_nascido_vivo
          }
        }

        nascido.registro.pessoa.nome = gemeo.nome

        return nascido
      },
      async gerarRegistros () {
        try {
          this.showModal =  false

          loader({ text: 'Cadastrando registro de Nascimento', active: true })

          for (const nascido of this.nascidos) {
            /**
             * Verificamos se algum dado faltante existe em algum registro que
             * pode ter sido importado
             */

            const  { registro: {pessoa, partes}, nascimento_informacao } = nascido

            if (!nascido.local && this.local) {
              nascido.local = this.local
            }

            if ((!pessoa.genitores || !pessoa.genitores.length) && this.genitores) {
              pessoa.genitores = this.genitores
            }

            if ((!partes || !partes.length) && this.partes) {
              nascido.registro.partes = this.partes
            }

            /**
             * Pegamos os valaores dos objetos e verificamos se tem algum que
             * não seja null, caso todos sejam null, passamos os dados do gemeo
             * para ele
             */
            const valuesNacInfo = Object.values(nascimento_informacao)
            const valueNotNull = valuesNacInfo.find(value => !!value)

            if ((!nascimento_informacao || (!valuesNacInfo.length || !valueNotNull)) && this.nascimento_informacao) {
              nascido.nascimento_informacao = this.nascimento_informacao
            }

            let dnv = nascido.registro.numero_declaracao_nascido_vivo
            nascido.cartorio_id = this.$store.state.auth.cartorio_id
            dnv = dnv ? dnv.replace(/-/g, '') : null
            nascido.registro.numero_declaracao_nascido_vivo = dnv || null
            nascido.registro.local = nascido.local || null
          }

          this.gerados = await NascimentoService.storeGemeos({gemeos: this.nascidos})

          const registrado = this.gerados.find(gerado => gerado.registrado)

          objSwal.success.title = 'Registro cadastrado!'
          objSwal.success.text = 'Registro de 2º via  de Nascimento cadastrado com sucesso.'

          await Swal.fire(objSwal.success).then(() => {
            return this.$router.push({
              name: 'resumo_nascimento',
              params: {
                id: registrado.nascimento_id,
                propNovo: true,
                propGerados: this.gerados,
                propGerarCPF: !!this.nascidos.find(nascido => nascido.gerar_cpf)
              }}).catch(() => {
              this.$router.push('/')
            })
          })

        } catch (error) {
          if (error.response) {
            await this.showError(error.response)
          } else {
            const message = getErrors(error)

            return displayMessage('error', 'Erro!', message.message)
          }
        } finally {
          loader({ text: '', active: false })
        }
      },
      async cadastrarNascimento () {
        try {
          loader({ text: 'Cadastrando 2ª via do registro de Nascimento', active: true })

          const nascimento = this.nascidos[0]

          let dnv = nascimento.registro.numero_declaracao_nascido_vivo
          nascimento.cartorio_id = this.$store.state.auth.cartorio_id
          dnv = dnv ? dnv.replace(/-/g, '') : null
          nascimento.registro.numero_declaracao_nascido_vivo = dnv || null
          nascimento.registro.local = nascimento.local || null

          await NascimentoService.storeNascimento(nascimento).then(async result => {

            const gerado = {
              ...nascimento,
              ...result,
              pessoa: {
                pessoa_id: result.pessoa_id
              }
            }

            const adicionado = this.gerados.find(ger => ger === gerado)

            if (!adicionado) this.gerados.push(gerado)
          })

          const registrado = this.gerados.find(gerado => gerado.registrado)

          objSwal.success.title = 'Registro cadastrado!'
          objSwal.success.text = 'Registro de 2º via  de Nascimento cadastrado com sucesso.'
          await Swal.fire(objSwal.success)

          return this.$router.push({
            name: 'resumo_nascimento',
            params: {
              id: registrado.nascimento_id,
              propNovo: false,
              propGerados: this.gerados,
              propGerarCPF: false,
              propTabSegundaVia: true,
            }
          }).catch(() => {
            this.$router.push('/')
          })
        } catch (error) {
          if (error.response) {
            await this.showError(error.response)
          } else {
            const message = getErrors(error)

            return displayMessage('error', 'Erro!', message.message)
          }
        } finally {
          loader({ text: '', active: false })
        }
      },
      receiveData (val) {
        this.registro = { ...val }
        this.registroUpdated = true
      },
      rascunhoId (val) {
        this.idNasc = val
      },
      receiveNascido (val) {
        this.dataToSend = { ...val}
        this.registroUpdated = false
      },
      async getCartorio () {
        this.dadosCartorio = this.$store.getters['auth/getCartorioObj']

        if (this.idNasc !== 'novo') {
          const rascunho =  await RegistrosService.getRascunhoById(this.idNasc)
          this.dataInicio = rascunho.created_at
          this.dadosCartorio = {...rascunho.document.registro}
        }
      },
      validateInputs () {
        this.registroUpdated = true
        this.$validator.validate().then(resp => {
          if (resp) {
            if (this.$route.params.id === 'novo') {
              return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
            }

            this.validateResgistro()

          } else {
            const invalids = document.querySelectorAll('.is-invalid')
            if (invalids.length) {
              invalids[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
            }
          }
        })
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao cadastrar'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error)
      },
      async showError (response) {
        try {
          if (Array.isArray(response.data)) {
            const messages = []

            response.data.forEach(resp => {
              switch (resp.message) {
              case 'required validation failed on registro.oficial':
                messages.push(`É necessário cadastrar o oficial no menu de serventia.`)
                break
              case 'unique validation failed on registro.numero_declaracao_nascido_vivo':
                messages.push(`DNV ${this.dataToSend.registro.numero_declaracao_nascido_vivo} já cadastrada.`)
                break
              }
            })

            const textSwal = `<ul>${messages.map(res => {
              return `<li>${res}</li>`
            })}</ul>`

            const html = textSwal.replace(/\,/g,'')

            return this.displayError('HTML', html)
          }
          if (response.data.message && !response.data.message.message) {
            return this.displayError('TEXT', response.data.message).then(() => {
              const msgs = [
                'Configuração do Livro inválida!',
                'Sequência do Livro inválida!',
                'Sequências dos livros',
                'Configurações dos livros'
              ]

              if (msgs.includes(response.data.message)) {
                this.$router.push({ name: 'cadastro_serventia', params: { propConfigLivro: true }})
              }
            })
          } else if (response.data && response.data.error && response.data.error.message) {
            if (response.data.error.message.match(/.*pessoa_cpf_unique.*/)) {
              const duplicate = response.data.error.message.match(/Duplicate entry (.*)/)[1]
              const cpf = duplicate.split(' ')[0]
              return this.displayError('TEXT', `Já existe uma pessoa cadastrada com o cpf ${cpf}`)
            } else {
              return this.displayError('TEXT', response.data.error.message)
            }
          }
          else {
            return this.displayError('Houve algum erro ao cadastrar um novo registro de nascimento, favor contactar o suporte.')
          }
        } catch (error) {
          return this.displayError('TEXT', 'Houve algum erro ao cadastrar um novo registro de nascimento, favor contactar o suporte.')
        }
      }
    },
  }
</script>

<style lang="scss">
@import '../../scss/_utilities/_exports';
</style>
